<script lang="ts" setup>
import { computed } from 'vue'
import type { ButtonSize } from '../DTButton/types'

const props = defineProps<{
  size?: Exclude<keyof typeof ButtonSize, 'xs'>
  as?: string
}>()

const buttonClass = computed(() => {
  switch (props.size) {
    case 'lg':
      return 'w-10 h-10'
    case 'sm':
      return 'w-6 h-6'
    case 'md':
    default:
      return 'w-8 h-8'
  }
})
</script>

<template>
  <DTButton
    :as="as"
    v-bind="$attrs"
    dense
    :class="buttonClass"
    class="!rounded-full"
  >
    <slot />
  </DTButton>
</template>
